import { combineReducers } from 'redux';
// Preserve initial state for not-yet-loaded reducers
const combine = (reducers, initialState={}) => {
  const reducerNames = Object.keys(reducers)
  Object.keys(initialState).forEach(item => {
    if (reducerNames.indexOf(item) === -1)
      reducers[item] = (state = null) => state
  })
  return reducers ? combineReducers(reducers) : []
}

export default combine


// WEBPACK FOOTER //
// ./src/store/combine.js